import { type UseMutationOptions, useMutation } from '@tanstack/vue-query'
import type { AxiosResponse } from 'axios'
import type { AddCuratedTravelItineraryPayload } from '../../types/api/payload/curatedTravel'
import type { AddCuratedTravelItinerarySuccessResponse } from '../../types/api/response/curatedTravel'
import { axiosInstance } from '@/modules/Core/plugins/axios'

export const MUTATION_KEY = 'add-curated-travel-itinerary'
export const ENDPOINT = '/influencer/Itinerary/AddItinerary'

export function addCuratedTravelItinerary(
  payload: AddCuratedTravelItineraryPayload
) {
  return axiosInstance.post<AddCuratedTravelItinerarySuccessResponse>(
    ENDPOINT,
    payload
  )
}

export function useAddCuratedTravelItineraryMutation(
  options?: UseMutationOptions<
    AxiosResponse<AddCuratedTravelItinerarySuccessResponse>,
    AxiosCustomError,
    AddCuratedTravelItineraryPayload,
    any
  >
) {
  return useMutation({
    mutationKey: [MUTATION_KEY],
    mutationFn: addCuratedTravelItinerary,
    ...options,
  })
}
